import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M22.499 10.5009L4.70902 10.5009L10.154 3.9609C10.4086 3.65458 10.5311 3.25966 10.4946 2.86302C10.458 2.46638 10.2653 2.10051 9.95902 1.8459C9.6527 1.59129 9.25778 1.4688 8.86114 1.50537C8.4645 1.54194 8.09863 1.73458 7.84402 2.0409L0.344023 11.0409C0.293564 11.1125 0.248442 11.1877 0.209023 11.2659C0.209023 11.3409 0.209024 11.3859 0.104024 11.4609C0.0360339 11.6329 0.000435119 11.816 -0.000976562 12.0009C0.000435119 12.1858 0.0360339 12.3689 0.104024 12.5409C0.104024 12.6159 0.104023 12.6609 0.209023 12.7359C0.248442 12.8141 0.293564 12.8893 0.344023 12.9609L7.84402 21.9609C7.98506 22.1302 8.16167 22.2664 8.36129 22.3597C8.56092 22.4531 8.77866 22.5013 8.99902 22.5009C9.3495 22.5016 9.68916 22.3795 9.95902 22.1559C10.1109 22.03 10.2365 21.8753 10.3285 21.7008C10.4205 21.5263 10.4772 21.3353 10.4953 21.1389C10.5134 20.9424 10.4926 20.7443 10.4341 20.5559C10.3755 20.3675 10.2803 20.1925 10.154 20.0409L4.70902 13.5009L22.499 13.5009C22.8968 13.5009 23.2784 13.3429 23.5597 13.0616C23.841 12.7803 23.999 12.3987 23.999 12.0009C23.999 11.6031 23.841 11.2215 23.5597 10.9402C23.2784 10.6589 22.8968 10.5009 22.499 10.5009Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
